import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'irembogov-redirect-interstitial',
  templateUrl: './redirect-interstitial.component.html',
  styleUrls: ['./redirect-interstitial.component.scss'],
})
export class RedirectInterstitialComponent implements OnInit {
  @Input() tokenEndpointUrl!: string;
  @Input() applicationId!: string;
  @Input() applicationNumber!: string;
  @Input() otp!: string;
  @Input() role!: string;
  @Input() resolverBaseUrl!: string;

  @Output() backEvent = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<string>();

  loading = true;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.generateTokenAndRedirect();
  }

  private generateTokenAndRedirect(): void {
    const headers = new HttpHeaders({
      applicationNumber: this.applicationNumber,
      otp: this.otp,
      applicationId: this.applicationId,
      role: this.role,
    });

    this.http
      .post<{ status: boolean; data?: { token: string }; message?: string }>(
        this.tokenEndpointUrl,
        null,
        { headers }
      )
      .subscribe({
        next: response => {
          if (response.status && response.data?.token) {
            const redirectUrl = `${this.resolverBaseUrl}/${this.applicationId}?token=${response.data.token}`;
            window.location.href = redirectUrl;
          } else {
            this.handleError(
              response.message || 'Failed to generate redirect token'
            );
          }
        },
        error: () => {
          this.handleError(
            'Unable to connect to the server. Please try again.'
          );
        },
      });
  }

  private handleError(message: string): void {
    this.loading = false;
    this.error = message;
    this.errorEvent.emit(message);
  }
}
